var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHospitalBed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.227,
    height: 23.237,
    viewBox: "0 0 23.227 23.237",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-hospitalization-4816306",
    transform: "translate(-60.004 -60.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27932",
    "data-name": "Path 27932",
    d: "M81.166,208.826a2.065,2.065,0,0,0,0-4.129h-.328v-8.563a.774.774,0,0,0-.774-.774H74.859a.774.774,0,0,0,0,1.548h1.363v.687h-.359a.431.431,0,0,0-.428.431v2.1a.431.431,0,0,0,.428.431h2.106a.431.431,0,0,0,.431-.431v-2.1a.431.431,0,0,0-.431-.431H77.61v-.687h1.677v7.784H68.156l-4.423-4.243a2.065,2.065,0,0,0-2.865,2.973l1.954,1.876v6.111H60.778a.774.774,0,0,0,0,1.548h1.881a1.525,1.525,0,1,0,1.876,0H77.463a1.523,1.523,0,1,0,1.874,0h2.488a.774.774,0,0,0,0-1.548h-2.65v-2.581Zm-3.541,2.581H64.373V206.79l1.52,1.461a2.065,2.065,0,0,0,1.432.575h10.3Z",
    transform: "translate(0 -132.448)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27933",
    "data-name": "Path 27933",
    d: "M249.608,380.073a1.259,1.259,0,0,0,0-1.778l-1.063-1.061a1.262,1.262,0,0,0-1.781,0l-.405.392,2.9,2.782Z",
    transform: "translate(-182.347 -310.05)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27934",
    "data-name": "Path 27934",
    d: "M406.447,61.2h-.934v-.937a.258.258,0,0,0-.258-.258h-1.081a.258.258,0,0,0-.258.258V61.2h-.937a.258.258,0,0,0-.258.258v1.081a.258.258,0,0,0,.258.258h.934v.937a.258.258,0,0,0,.258.258h1.081a.258.258,0,0,0,.258-.258v-.937h.937a.258.258,0,0,0,.258-.258V61.454a.258.258,0,0,0-.258-.258Z",
    transform: "translate(-335.346)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospitalBed);
export default __webpack_public_path__ + "static/media/hospital_bed.30a9bae8c32b02f668faf767939f96b9.svg";
export { ForwardRef as ReactComponent };